<template>

  <div id="ca-sidesheet-edicion">

    <ca-sidesheet
      :show.sync="show"
      titulo="EDITAR ACUERDO"
      width="600px"
      :close_outside= false
      :loading=loading
      botonera_inferior
    >

      <!-- Contenido de sidesheet -->
      <div class="contenedor-sidesheet" v-if="acuerdo_comercial_copy">

        <!-- Header de sidesheet -->
        <header-label-tipo-acuerdo-comercial-sidesheet :acuerdo_comercial="acuerdo_comercial" />

        <!-- Detalle de estados (mostrar siguiente estado condicionado por vista actual del sidesheet y si el acuerdo tiene mapeo de siguiente estado) -->
        <detalle-estado-acuerdo-comercial :acuerdo_comercial="acuerdo_comercial" :mostrar_siguiente_estado="show_vista_previa" :solo_cambios_atributos_internos="solo_cambios_atributos_internos" />

        <!-- Vista condicionada con v-if, para forzar que se desmonte y monte, asi los watchs detectan los cambios de una unica vista -->
        <vista-formulario-campos-principales-acuerdo
          v-if="show_vista_edicion_acuerdo"
          ref="vista_formulario_campos_principales_acuerdo"
          :acuerdo_comercial.sync="acuerdo_comercial_copy"
          modo_edicion
          @formulario-campos-principales:valido="edicion_formulario_campos_principales_valida = $event"
        >

          <div slot="pre-formulario" class="mb-4">

            <div v-if="acuerdo_comercial_copy.tipo_propuesta === TIPO_ACUERDO_POR_DEFECTO">
              <ca-chip
                :item="{'label': 'Las modificaciones tendrán efecto sólo sobre los nuevos consorcios de la administración ' + acuerdo_comercial_copy.administracion.nombre + '.'}"
                disabled
                outline
                contentClass="chip-custom chip-informativo"
              >
                <div slot="izquierda">
                  <v-icon class="icon-info">info</v-icon>
                </div>
              </ca-chip>
            </div>

            <div v-if="acuerdo_comercial_copy.tipo_propuesta === TIPO_ACUERDO_VINCULADO_AL_CONSORCIO && this.acuerdo_comercial_copy.consorcio.facturando">
              <ca-chip
                :item="{'label': 'El consorcio ya entró en el ciclo de facturación.<br><b>No es posible editar esta sección.</b>'}"
                disabled
                outline
                contentClass="chip-custom chip-warning"
              >
                <div slot="izquierda">
                  <v-icon class="icon-warning">warning</v-icon>
                </div>
              </ca-chip>
            </div>

          </div>

        </vista-formulario-campos-principales-acuerdo>

        <!-- Vista previa -->
        <vista-previa-acuerdo
          v-if="show_vista_previa"
          :acuerdo_comercial="acuerdo_comercial_copy"
          modo_eliminacion
        >

          <!-- Utilizamos el slot para mostrar el chip informativo solo en el caso del tipo de acuero por defecto -->
          <div slot="pre-unidades-funcionales" v-if="this.acuerdo_comercial_copy.tipo_propuesta === TIPO_ACUERDO_POR_DEFECTO" class="mb-4">
            <ca-chip
              disabled
              outline
              contentClass="chip-custom chip-informativo"
            >
              <template>
                <div slot="izquierda">
                  <v-icon class="icon-info">info</v-icon>
                </div>

                <!-- Mensajes a mostrar en el chip informativo -->
                <strong>No se modificarán acuerdos existentes.</strong>
                <div>
                  Los cambios aplicarán para consorcios de la administración activados luego de la modificación de este acuerdo.
                </div>
              </template>
            </ca-chip>
          </div>

        </vista-previa-acuerdo>

        <!-- Tabla total a facturar (opcional) -->
        <div v-if="acuerdo_comercial_copy.tipo_propuesta === TIPO_ACUERDO_VINCULADO_AL_CONSORCIO && show_vista_previa" class="pt-4">

          <!-- Utilizamos el slot para inyectar la tabla de totales a facturar -->
          <div slot="post-observaciones-facturacion">
            <tabla-total-a-facturar-acuerdo-comercial
              v-if="acuerdo_comercial_copy.consorcio"
              :acuerdo_comercial="acuerdo_comercial_copy"
              :consorcio="acuerdo_comercial_copy.consorcio"
            />
          </div>

        </div>
      </div>

      <!-- Botonera inferior -->
      <div slot="footer-izquierda">
        <v-btn class="boton--cancelar" @click="cancelarEdicion()">Cancelar</v-btn>
      </div>
      <div slot="footer-derecha">

        <!-- Mostramos el boton de reestablecer solo si se edito algun campo -->
        <v-btn
          v-if="hayCambios && show_vista_edicion_acuerdo || show_vista_previa"
          outlined
          class="boton--outlined"
          @click="hayCambios && show_vista_edicion_acuerdo ? reestablecerSidesheet() : pasoAnterior()"
        >
          {{ hayCambios && show_vista_edicion_acuerdo ? 'Reestablecer' : 'Atrás' }}
        </v-btn>

        <!-- Si no hubo cambios deshabilitmaos el boton de siguiente (para limitar el vance). Si hubo cambios se muestran tanto el boton siguiente como el reestablecer -->
        <v-btn class="mr-4" :disabled="show_vista_edicion_acuerdo && !hayCambios" @click="botonAccion()">
          {{ show_vista_edicion_acuerdo ? 'Siguiente' : 'Guardar' }}
        </v-btn>

      </div>

    </ca-sidesheet>

  </div>
</template>

<script>
import { AcuerdoComercial } from '../../../models/AcuerdoComercial';
import VistaPreviaAcuerdo from './vistas-sidesheet/VistaPreviaAcuerdo.vue';
import * as ac_constantes from '../acuerdo-comercial.consts';
import { formatFecha } from '@/components/vue_filters';
import { trimUsuarioSales } from '../acuerdo-comercial.helpers';
import { APIAcuerdoComercial } from '../api/acuerdo-comercial.api';
import './vistas-sidesheet/vistas-sidesheet-style.scss'; // Estilos en común para las vistas
import HeaderLabelTipoAcuerdoComercialSidesheet from './HeaderLabelTipoAcuerdoComercialSidesheet.vue';
import DetalleEstadoAcuerdoComercial from './DetalleEstadoAcuerdoComercial.vue';
import TablaTotalAFacturarAcuerdoComercial from './TablaTotalAFacturarAcuerdoComercial.vue';
import VistaFormularioCamposPrincipalesAcuerdo from './vistas-sidesheet/VistaFormularioCamposPrincipalesAcuerdo.vue';

/**
 * Sidesheet para la edción de un acuerdo comercial, se tiene un camino con las vistas a mostrar
 * 
 * Para la sección de detalles de estados, el siguiente estado queda alineado con la vista que se esta viendo actualmente en el camino
 * 
 * Para poder avanzar en los pasos del camino de la edición de un acuerdo comercial, es necesario realizar alguna modificación en los campos del formulario de edición de un acuerdo comercial (si no hay cambios no se habilitará el botón para continuar con la edición). 
 * Si hubo cambios se habilita el botón de siguiente y reestablecer (este botón reinicia los valores del acuerdo comercial original sin modificaciones).
 * Al momento de avanzar en los pasos del camino de la edición de un acuerdo comercial, se valida que el formulario sea válido (los campos requeridos estén completados).
 * 
 */
export default {
  name: 'SidesheetEdicionAcuerdo',
  components: {
    VistaPreviaAcuerdo,
    VistaFormularioCamposPrincipalesAcuerdo,
    HeaderLabelTipoAcuerdoComercialSidesheet,
    DetalleEstadoAcuerdoComercial,
    TablaTotalAFacturarAcuerdoComercial
  },
  props:{
    show: { type: Boolean, default: false },
    acuerdo_comercial: { type: AcuerdoComercial, default: null }
  },
  data: () =>({

    // Serie de pasos para la edición del acuerdo comercial. Paso actual indica el paso en el que estamos actualmente
    camino_actual: {
      camino: ac_constantes.CAMINO_EDICION_ACUERDO_COMERCIAL,
      paso_actual: 0
    },

    acuerdo_comercial_copy: null,
    edicion_formulario_campos_principales_valida: true,

    loading: false,

    TIPO_ACUERDO_VINCULADO_AL_CONSORCIO: ac_constantes.TipoAcuerdo.CONSORCIO,
    TIPO_ACUERDO_POR_DEFECTO: ac_constantes.TipoAcuerdo.ADMINISTRACION,
    TIPO_ACUERDO_LIBRE: ac_constantes.TipoAcuerdo.LIBRE, // [acuerdo_libre - no esta en uso actualmente]

    // Flag que indica el estado de la validación del formulario al editar los campos principales del acuerdo comercial
    formulario_valido: true,

    solo_cambios_atributos_internos: false // Flag para indicar si solo se editaron los atributos internos del acuerdo comercial
  }),
  computed: {

    /**
     * Computed para detectar los cambios en el acuerdo
     */
    hayCambios(){
      return !_.isEqual(this.acuerdo_comercial, this.acuerdo_comercial_copy);
    },

    // Computed para activar la vista de edición de acuerdo
    show_vista_edicion_acuerdo() {
      return this.camino_actual.camino[this.camino_actual.paso_actual] === ac_constantes.VISTA_EDICION_ACUERDO && this.show;
    },

    // Computed para activar la vista de vista previa
    show_vista_previa() {
      return this.camino_actual.camino[this.camino_actual.paso_actual] === ac_constantes.VISTA_PREVIA && this.show;
    }
  },
  watch: {

    /**
     * Al activarse el sidesheet, actualiza el tab inicial/acuerdo y precarga las vistas
     */
    show(new_value){
      if(new_value){
        this.acuerdo_comercial_copy = _.cloneDeep(this.acuerdo_comercial);
        this.camino_actual.paso_actual = 0; // Reiniciamos el camino al primer paso
        if(this.$refs.vista_formulario_campos_principales_acuerdo){
          this.$refs.vista_formulario_campos_principales_acuerdo.preCargarCreacion(this.acuerdo_comercial_copy);
        }

      }
      else{
        this.acuerdo_comercial_copy = null;
      }
    }

  },
  methods: {
    trimUsuarioSales,
    formatFecha,

    /**
     * Metodo para reestablecer a los valores por defecto del acuerdo comercial
     */
    reestablecerSidesheet() {
      this.acuerdo_comercial_copy = _.cloneDeep(this.acuerdo_comercial);

      // Si estamos en la vista de edición, reiniciamos el formulario
      if(this.show_vista_edicion_acuerdo && this.$refs.vista_formulario_campos_principales_acuerdo) {
        this.$refs.vista_formulario_campos_principales_acuerdo.preCargarCreacion(this.acuerdo_comercial_copy); // Reiniciamos la vista con los valores por defecto (y forzamos a que actualice los valores de los acuerdos comerciales con los originales)
      }
    },

    /**
     * Posiciona el scroll arriba del todo del sidesheet
     */
    posicionarArribaScroll() {
      const sidesheet_content = document.querySelector('#ca-sidesheet-edicion  .ca-sidesheet-content');
      if (sidesheet_content) {
        sidesheet_content.scrollTop = 0;
      }
    },

    /**
     * Metodo para avanzar al siguiente paso en la edición del acuerdo comercial
     */
    siguientePaso() {
      if(this.camino_actual.paso_actual === 0){
        ++this.camino_actual.paso_actual;
        this.posicionarArribaScroll(); // Posicionamos el scroll arriba del sidesheet
      }
    },

    /**
     * Metodo para retroceder al paso anterior en la edición del acuerdo comercial
     */
    pasoAnterior() {
      if(this.camino_actual.paso_actual > 0) {
        --this.camino_actual.paso_actual;
      }
      this.posicionarArribaScroll(); // Posicionamos el scroll arriba del sidesheet
    },

    /**
     * Metodo ejecutado al cancelar la edición del AC desde el sidesheet
     */
    cancelarEdicion(){
      this.$emit('update:show', false);
    },

    /**
     * Metodo que determina si en la edición del acuerdo comercial se modificaron únicamente los atributos internos
     * Los atributos internos son aquellos que, si se editan, no modifican el estado actual del acuerdo comercial
     *  - Buscamos las diferencias entre el acuerdo comercial original y el acuerdo comercial editado
     *  - Si las únicas diferencias son los atributos internos del acuerdo comercial, se devuelve verdadero, falso en caso contrario
     */
    async soloCambioAtributosInternos() {
      const diferencias = _.omitBy(this.acuerdo_comercial, (value, key) =>
        _.isEqual(value, this.acuerdo_comercial_copy[key])
      );

      return new Promise(resolve => {
        resolve(Object.keys(diferencias).length === 1 && 'observaciones' in diferencias);
      });
    },

    /**
     * Metodo ejecutado al confirmar los cambios del AC desde el sidesheet
     */
    guardarCambios(){
      this.loading = true;
      APIAcuerdoComercial.actualizarAcuerdoComercial(this.acuerdo_comercial_copy.getApiLinkHref('editar'), this.acuerdo_comercial_copy, this.acuerdo_comercial)
        .then((acuerdo_editado) => {
          this.$emit('acuerdo-comercial-edicion:exito', acuerdo_editado);
        })
        .catch((err) => {
          this.$emit('acuerdo-comercial-edicion:error', err);
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
          this.acuerdo_comercial_copy = null; // apago vista previa y creación
          this.$emit('update:show', false);
        });
    },

    /**
     * Calcula la acción dinamica dependiendo del label que tenga
     */
    async botonAccion(){

      // Verificamos que exista el ref y actualizamos el estado de la validación del formulario
      if(this.$refs.vista_formulario_campos_principales_acuerdo) {
        this.formulario_valido = await this.$refs.vista_formulario_campos_principales_acuerdo.validarFormulario();
      }

      // Validamos que estamos en la vista de edición y el formulario es valido
      if(this.show_vista_edicion_acuerdo && this.formulario_valido){
        this.solo_cambios_atributos_internos = await this.soloCambioAtributosInternos();
        return this.siguientePaso();
      }

      // Validamos que estamos en la vista de vista previa y el formulario es valido
      if(this.show_vista_previa && this.formulario_valido) {
        return this.guardarCambios();
      }
    },
  },
};
</script>

<style lang="scss">

#ca-sidesheet-edicion{

  .v-toolbar__title {
    color: color(blanco);
    font-size: 20px;
    line-height: 24px;
    font-weight: 400;
  }

  .boton {

    &--cancelar {
      color: color(negro);
      background-color: inherit;
      box-shadow: none;
      margin-left:8px;
    }

    &--outlined {
      color: color(naranja);
      background-color: inherit;
    }

  }
}
</style>